import * as types from './types';

const INITIAL_STATE = {
  cnVersionInformation: {},
  cnVersionInformationFetchError: null,
  cnVersionUpdateEnqueueError: null,
  cnVersionInformationFetchLoading: false,
  cnVersionUpdateEnqueueLoading: false,
  cnVersionUpdateEnqueuedSuccessfully: false,
  cnPreviewEnqueuedSuccessfully: false,
  cnPreviewEnqueuedLoading: false,
  cnUpdateLoading: false,
  cnPreviewLoading: false,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.CN_VERSION_GET_VERSION_INFORMATION: {
      return {
        ...state,
        cnVersionInformation: payload,
        cnUpdateLoading: payload.UpdateInProgress,
        cnPreviewLoading: payload.PreviewInProgress,
      };
    }
    case types.CN_VERSION_GET_VERSION_INFORMATION_ERROR: {
      return { ...state, cnVersionInformationFetchError: payload };
    }
    case types.CN_VERSION_GET_VERSION_INFORMATION_LOADING: {
      return {
        ...state,
        cnVersionInformationFetchLoading: payload,
      };
    }
    case types.CN_VERSION_ENQUEUE_UPDATE_LOADING: {
      return { ...state, cnVersionUpdateEnqueueLoading: payload };
    }
    case types.CN_VERSION_ENQUEUE_PREVIEW_LOADING: {
      return { ...state, cnPreviewEnqueuedLoading: payload };
    }
    case types.CN_VERSION_SET_ENQUEUED_SUCCESSFUL: {
      return { ...state, cnVersionUpdateEnqueuedSuccessfully: payload };
    }
    case types.CN_VERSION_ENQUEUE_UPDATE_ERROR: {
      return { ...state, cnVersionUpdateEnqueueError: payload };
    }
    case types.CN_VERSION_UPDATE_LOADING: {
      return { ...state, cnUpdateLoading: payload };
    }
    case types.CN_VERSION_SET_PREVIEW_ENQUEUED_SUCCESSFUL: {
      return { ...state, cnPreviewEnqueuedSuccessfully: payload };
    }
    case types.CN_VERSION_PREVIEW_LOADING: {
      return { ...state, cnPreviewLoading: payload };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/CNVersionInformation/reducer.js